import { EndUserComponent, EndUserPages } from '@aurora/shared-types/pages/enums';
import dynamic from 'next/dynamic';
import React from 'react';
import type { BreadcrumbItem } from '../../../components/context/BreadcrumbContext/BreadcrumbContext';
import BasePage from '../../../components/page/BasePage/BasePage';
import useTranslation from '../../../components/useTranslation';

const SearchActionMenu = dynamic(
  () => import('../../../components/community/Search/SearchActionMenu/SearchActionMenu')
);

/**
 * Search Results Page
 *
 * @author Amit Agrawal
 */
const SearchResultsPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { formatMessage, loading: textLoading } = useTranslation(
    EndUserComponent.SEARCH_RESULTS_PAGE
  );

  if (textLoading) {
    return null;
  }

  function decorateBreadcrumbs(breadcrumbs: BreadcrumbItem[]): BreadcrumbItem[] {
    return [
      ...breadcrumbs,
      {
        id: 'page:search/SearchResultsPage',
        title: formatMessage('breadCrumbTitle')
      }
    ];
  }

  /**
   * Renders the Category action menu.
   */
  function renderSearchActionMenu(): React.ReactElement {
    return <SearchActionMenu />;
  }

  return (
    <BasePage
      pageId={EndUserPages.SearchResultsPage}
      breadcrumbActionComponents={[renderSearchActionMenu]}
      decorateBreadcrumbs={decorateBreadcrumbs}
      showLoading={textLoading}
      nextSeoProps={{ noindex: true, nofollow: true }}
    />
  );
};

export default SearchResultsPage;
